import {
  queryLoginWx,
  getLoginWechatAccount,
  getAllWechatAccount,
  getWechatLoginQRCode,
  confirmLogin,
  getFriendList,
  modifyFriendInfo,
  sendText
} from '@/api/eyunserv'

export default {
  state: {
    state_Eyun_QueryLoginWxResult: null,
    state_Eyun_GetLoginWechatAccountResult: null,
    state_Eyun_GetAllWechatAccountResult: null,
    state_Eyun_GetWechatLoginQRCodeResult: null,
    state_Eyun_ConfirmLoginResult: null,
    state_Eyun_GetFriendListResult: null,
    state_Eyun_ModifyFriendInfoResult: null,
    state_Eyun_SendTextResult: null
  },
  mutations: {
    SET_EYUN_QUERYLOGINWX_RESULT: (state, rst) => {
      state.state_Eyun_QueryLoginWxResult = rst
    },
    SET_EYUN_GETLOGINWECHATACCOUNT_RESULT: (state, rst) => {
      state.state_Eyun_GetLoginWechatAccountResult = rst
    },
    SET_EYUN_GETALLWECHATACCOUNT_RESULT: (state, rst) => {
      state.state_Eyun_GetAllWechatAccountResult = rst
    },
    SET_EYUN_GETWECHATLOGINQRCODE_RESULT: (state, rst) => {
      state.state_Eyun_GetWechatLoginQRCodeResult = rst
    },
    SET_EYUN_CONFIRMLOGIN_RESULT: (state, rst) => {
      state.state_Eyun_ConfirmLoginResult = rst
    },
    SET_EYUN_GETFRIENDLIST_RESULT: (state, rst) => {
      state.state_Eyun_GetFriendListResult = rst
    },
    SET_EYUN_MODIFYFRIENDINFO_RESULT: (state, rst) => {
      state.state_Eyun_ModifyFriendInfoResult = rst
    },
    SET_EYUN_SENDTEXT_RESULT: (state, rst) => {
      state.state_Eyun_SendTextResult = rst
    }
  },
  actions: {
    EyunServ_QueryLoginWx ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        queryLoginWx(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_EYUN_QUERYLOGINWX_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_EYUN_QUERYLOGINWX_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    EyunServ_GetLoginWechatAccount ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getLoginWechatAccount(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_EYUN_GETLOGINWECHATACCOUNT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_EYUN_GETLOGINWECHATACCOUNT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    EyunServ_GetAllWechatAccount ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAllWechatAccount(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_EYUN_GETALLWECHATACCOUNT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_EYUN_GETALLWECHATACCOUNT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    EyunServ_GetWechatLoginQRCode ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getWechatLoginQRCode(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_EYUN_GETWECHATLOGINQRCODE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_EYUN_GETWECHATLOGINQRCODE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    EyunServ_ConfirmLogin ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmLogin(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_EYUN_CONFIRMLOGIN_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_EYUN_CONFIRMLOGIN_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    EyunServ_GetFriendList ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getFriendList(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_EYUN_GETFRIENDLIST_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_EYUN_GETFRIENDLIST_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    EyunServ_ModifyFriendInfo ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyFriendInfo(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_EYUN_MODIFYFRIENDINFO_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_EYUN_MODIFYFRIENDINFO_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    EyunServ_SendText ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        sendText(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_EYUN_SENDTEXT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_EYUN_SENDTEXT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_Eyun_QueryLoginWxResult: state => {
      return state.state_Eyun_QueryLoginWxResult
    },
    get_Eyun_GetLoginWechatAccountResult: state => {
      return state.state_Eyun_GetLoginWechatAccountResult
    },
    get_Eyun_GetAllWechatAccountResult: state => {
      return state.state_Eyun_GetAllWechatAccountResult
    },
    get_Eyun_GetWechatLoginQRCodeResult: state => {
      return state.state_Eyun_GetWechatLoginQRCodeResult
    },
    get_Eyun_ConfirmLoginResult: state => {
      return state.state_Eyun_ConfirmLoginResult
    },
    get_Eyun_GetFriendListResult: state => {
      return state.state_Eyun_GetFriendListResult
    },
    get_Eyun_ModifyFriendInfoResult: state => {
      return state.state_Eyun_ModifyFriendInfoResult
    },
    get_Eyun_SendTextResult: state => {
      return state.state_Eyun_SendTextResult
    }
  }
}
